import { buildParams } from '@/helpers/url';

const initialState = {
  cycles: null,
  selectedPotentialCycle: null,
  selectedPerformanceCycle: null,
};

const actions = {
  async getNineBoxTemplate() {
    const templatePath = `${this._vm.$newEndPoint}/nine-box/get-template`;

    try {
      const { data } = await this._vm.$axios.get(templatePath);

      if (data.contents) return data.contents;
      throw Error('Invalid response');
    } catch (err) {
      throw Error(err);
    }
  },
  async getDropdownCycles(context, params) {
    const queries = buildParams(params);
    const matrixPath = `${this._vm.$endPoint}/nine-box-matrix/dropdown-cycle?`;

    try {
      const { data } = await this._vm.$axios.get(matrixPath + queries);

      return data.contents || [];
    } catch (err) {
      throw Error(err);
    }
  },
  async downloadXls(context, params) {
    const queries = buildParams(params);
    const matrixPath = `${this._vm.$endPoint}/nine-box-matrix/download-xls?`;

    try {
      const response = await this._vm.$axios({ method: 'GET', url: `${matrixPath}${queries}`, responseType: 'blob' });

      if (response.status === 200) return response.data;
      throw response.statusMessage || response.message;
    } catch (err) {
      throw Error(err);
    }
  },
  async getNineBoxEmployees(context, params) {
    try {
      const queries = buildParams(params);
      const matrixPath = `${this._vm.$endPoint}/nine-box-matrix/employee-list-matrix?`;
      const response = await this._vm.$axios.get(matrixPath + queries);

      if (!response) throw new Error('invalid response');
      if (response.errors || response.error) throw new Error(response.message);
      return response.data.contents || {};
    } catch (err) {
      throw Error(err);
    }
  },
};

const mutations = {
  SET_CYCLES(state, payload) {
    if (Array.isArray(payload)) state.cycles = [...payload];
    else state.cycles = payload;
  },
  SET_POTENTIAL_CYCLE(state, payload) {
    state.selectedPotentialCycle = { ...payload };
  },
  SET_PERFORMANCE_CYCLE(state, payload) {
    state.selectedPerformanceCycle = { ...payload };
  },
};

export default {
  namespaced: true,
  state: () => ({ ...initialState }),
  mutations,
  actions,
};
